
import { supabase } from "@/integrations/supabase/client";

// Get a list of conversations from ElevenLabs
export const getConversations = async (
  limit: number = 20,
  offset: number = 0
): Promise<{ success: boolean; conversations?: any[]; error?: string }> => {
  try {
    console.log(`Fetching ${limit} conversations with offset ${offset}`);
    
    const { data, error } = await supabase.functions.invoke("get-elevenlabs-conversations", {
      body: { limit, offset },
    });

    if (error) throw error;
    if (!data.success) throw new Error(data.error || "Failed to fetch conversations");

    return { 
      success: true, 
      conversations: data.conversations || []
    };
  } catch (error) {
    console.error("Error fetching conversations:", error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : "An unknown error occurred" 
    };
  }
};

/**
 * Fetches a single conversation by ID from ElevenLabs API
 * @param conversationId The ID of the conversation to fetch
 * @param includeAudio Whether to include audio data in the response
 * @returns Promise with conversation or error
 */
export const getConversation = async (
  conversationId: string,
  includeAudio: boolean = false
) => {
  try {
    const { data, error } = await supabase.functions.invoke("get-elevenlabs-conversation", {
      body: { conversation_id: conversationId, include_audio: includeAudio },
    });

    if (error) throw error;
    if (!data.success) throw new Error(data.error || "Failed to fetch conversation");

    return { 
      success: true, 
      conversation: data.conversation,
      audio: data.audio
    };
  } catch (error) {
    console.error("Error fetching conversation:", error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : "An unknown error occurred" 
    };
  }
};

/**
 * Fetches the audio for a conversation from ElevenLabs API
 * @param conversationId The ID of the conversation to fetch audio for
 * @returns Promise with audio data or error
 */
export const getConversationAudio = async (conversationId: string) => {
  try {
    // We'll use the same endpoint but with the include_audio flag
    const result = await getConversation(conversationId, true);
    if (!result.success) throw new Error(result.error);
    
    return { 
      success: true, 
      audio: result.audio 
    };
  } catch (error) {
    console.error("Error fetching conversation audio:", error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : "An unknown error occurred" 
    };
  }
};
